import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTableAssignedServices.css";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button, SelectField } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import Autocomplete from "@material-ui/lab/Autocomplete";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import {
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Radio,
} from "@material-ui/core";
import "../styles/cityTableCustomiseSP.css";

const SponsorshipRulesTable = (props) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [advSpRulesOnPlanResponse, setAdvSpRulesOnPlanResponse] = useState(
    props?.data?.advSpRulesOnPlanResponse
  );
  const [tableData, setTableData] = useState(
    props?.data?.advSpRulesOnPlanResponse?.rules ?? []
  );
  const [filterObj, setFilterObj] = useState({});
  const [serviceId, setServiceId] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("props recvd in expandabel table: ", props);
  }, []);

  useEffect(() => {
    setTableData(props?.data?.advSpRulesOnPlanResponse?.rules ?? []);
    console.log("props recvd in expandabel table: ", props);
  }, [props]);

  const STATUS_LIST = [
    { name: "Saved as draft", value: 1 },
    { name: "Published", value: 2 },
    { name: "Unpublished", value: 3 },
  ];

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id); // toggle expansion
  };
  const handleMoreClick = (event, service) => {
    setAnchorEl(event.currentTarget);
    setMenuFor({ planData: props?.data?.planData, service: service });
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  return (
    <div className="table-container-assigned-plans">
      <table className="expandable-table">
        <thead>
          <tr>
            <th>Rule ID</th>
            <th>Service type</th>
            <th>Service codes added</th>
            <th>Published by</th>
            <th>Unpublished by</th>
            <th>
              Status
              <img
                className="filter-icon-assigned-plans"
                src={filterObj?.status ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    multiple
                    id="appointment-dialog-client-code-filter"
                    className="appointment-dialog-client-code-filter-class"
                    options={STATUS_LIST}
                    value={filterObj?.status ?? []} //statusFilterValue
                    onChange={(e, v) => {
                      if (v.length > 0) {
                        if (props?.getAdvSpRulesOnPlanByFilter) {
                          props.getAdvSpRulesOnPlanByFilter(
                            props?.data?.planData?.id,
                            {
                              ...(filterObj ?? {}),
                              status: (v ?? []).map((elemm) => elemm?.value),
                            }
                          );
                          setFilterObj((prev) => ({
                            ...prev,
                            status: v ?? [],
                          }));
                        }
                      } else {
                        if (props?.getAdvSpRulesOnPlanByFilter) {
                          props.getAdvSpRulesOnPlanByFilter(
                            props?.data?.planData?.id,
                            { ...(filterObj ?? {}), status: [] }
                          );
                          setFilterObj((prev) => ({ ...prev, status: [] }));
                        }
                      }
                    }}
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder={"Type status name"} />
                    )}
                  />
                </div>
              )}
            </th>
          </tr>
        </thead>
        <tbody className="animated-box">
          {Boolean(tableData?.length == null || tableData?.length <= 0) && (
            <tr>
              <td colSpan={10}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 40,
                  }}
                >
                  <div
                    style={{ textAlign: "center", fontFamily: "Montserrat" }}
                  >
                    No records to show
                  </div>
                  <div style={{ height: "16px" }}></div>
                  <img src={NoRecordsIcon} width={50} height={62} />
                </div>
              </td>
            </tr>
          )}

          {/* {tableData && tableData.length > 0 && (
            <tr>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td
                colSpan={10}
                align="right"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Button
                  onClick={() => {
                    props.goToPrevPage();
                  }}
                  disabled={props?.pageNum <= 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">arrow_left</FontIcon>
                </Button>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {(props?.pageNum - 1) * props?.pageSize + 1}&nbsp;
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                    }}
                  >
                    -
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    &nbsp;
                    {props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount}
                  </span>
                  <span>&nbsp;&nbsp;of&nbsp;</span>
                  <span>{` ${props?.totalCount}`}</span>
                </div>
                <Button
                  onClick={() => {
                    props.goToNextPage();
                  }}
                  disabled={
                    loading ||
                    props?.pageNum * props?.pageSize > props?.totalCount ||
                    (props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount) == props?.totalCount
                  }
                >
                  <FontIcon>arrow_right</FontIcon>
                </Button>
              </td>
              <td />
            </tr>
          )} */}

          {tableData.map((row, index) => (
            <React.Fragment key={index}>
              <tr
                // onClick={() => handleRowClick(row?.id)}
                className={`${index > 0 ? "table-row-border" : ""}`}
              >
                <td
                  style={{
                    cursor: "pointer",
                    fontWeight: 700,
                    textDecoration: "underline",
                  }}
                  onClick={(e) => {
                    if (
                      row?.id &&
                      (row?.status === 1 ||
                        row?.status === 2 ||
                        row?.status === 3)
                    ) {
                      if (props?.data?.planData?.id) {
                        props.setView(7, {
                          mode:
                            row?.status === 2 || row?.status === 3
                              ? "view"
                              : "update",
                          accountId: props?.data?.accountId,
                          planId: props.data.planData.id,
                          serviceGroupRuleId: row.id,
                        });
                      } else {
                        EventService.emit("showError", {
                          message: `Unable to get plan id`,
                        });
                      }
                    }
                  }}
                >
                  {row?.id}
                </td>
                <td>
                  {
                    Object.values(row?.serviceDetailsMap ?? {})?.[0]
                      ?.serviceTypeName
                  }
                </td>
                <td>
                  {(() => {
                    const serviceCodes = Object.entries(
                      row?.serviceDetailsMap ?? {}
                    )
                      .map(([_, value]) => value?.name ?? "")
                      .join(", ");
                    return serviceCodes.length > 290
                      ? serviceCodes.slice(0, 290) + "..."
                      : serviceCodes;
                  })()}
                </td>
                <td>
                  {row?.status === 2 || row?.status === 3 ? (
                    <>
                      {row?.publishedByName ?? "-"}
                      <br />
                      {moment
                        .utc(row?.publishedAt)
                        .local()
                        .format("D MMM YYYY, h:mm A")}
                    </>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  {row?.status === 3 ? (
                    <>
                      {row?.updatedByName ?? "-"}
                      <br />
                      {moment
                        .utc(row?.updatedAt)
                        .local()
                        .format("D MMM YYYY, h:mm A")}
                    </>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  {Boolean(
                    row?.status === 1 || row?.status === 2 || row?.status === 3
                  ) ? (
                    <div
                      className={`${
                        row?.status === 1
                          ? "adv-sp-rule-status-draft"
                          : row?.status === 2
                          ? "adv-sp-rule-status-published"
                          : row?.status === 3
                          ? "adv-sp-rule-status-unpublished"
                          : ""
                      }`}
                      // adv-sp-rule-status-draft
                    >
                      {`${
                        row?.status === 1
                          ? "Saved as draft"
                          : row?.status === 2
                          ? "Published"
                          : row?.status === 3
                          ? "Unpublished"
                          : ""
                      }`}
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {openBackdrop && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
          }}
          onClick={() => {
            setOpenFilter(-1);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default SponsorshipRulesTable;
